// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__1qXxi","section":"styles_section__2NBj-","col":"styles_col__3Fnq6","content":"styles_content__1BsHe","title":"styles_title__oXnZL"};